import script from "./RequestUpdateModalForProductInfos.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestUpdateModalForProductInfos.vue?vue&type=script&setup=true&lang=js"

import "./RequestUpdateModalForProductInfos.vue?vue&type=style&index=0&id=1b9c21af&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b9c21af"]])

export default __exports__